export default __webpack_public_path__ + "4b25379519ce92bc9a6453176d48b9e9.mp4";